var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('div',{staticClass:"page-head-default",attrs:{"slot":"head"},slot:"head"},[_vm._v(" "+_vm._s(_vm.i18n.continue_with_whatsapp)+" ")]),_c('div',{staticClass:"login-wa-complete-warp"},[_c('div',{staticClass:"top-tips"},[_vm._v(_vm._s(_vm.i18n.approved_redirecting))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }